
  <div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header">
            <div class="row">
                <div class="form-group col-1.5 ml-2">
                  <label>Dharmshala</label>
                  <select class="form-control border-primary" name="dharmshala_id" [(ngModel)]="dharmshala_id" (ngModelChange)="onDharmshalaChange()">
                    <option value="">All</option>
                    <option *ngFor="let dharmshala of allDharmshala" [value]="dharmshala.id">{{dharmshala.name}}</option>
                  </select>
                </div>
                <div class="form-group col-2 ml-2">
                  <label>Room Type</label>
                  <select class="form-control border-primary" name="room_type_id" [(ngModel)]="room_type_id">
                    <option value="">All</option>
                    <option *ngFor="let roomType of allRoomTypes" [value]="roomType.id">{{roomType.name}}</option>
                  </select>
                </div>
                <div class="form-group col-1.5 ml-2">
                  <label>From Date</label>
                  <input class="form-control border-primary" [max] = "to_date" [owlDateTime]="dt" placeholder="Date" name="from_date"
                    [(ngModel)]="from_date" readonly>
                  <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                  <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>
                <div class="form-group col-1.5 ml-2 mr-2">
                    <label>To Date</label>
                    <input class="form-control border-primary" [min]="from_date" [max] = "maxDate" [owlDateTime]="dt1" placeholder="Date" name="to_date"
                      [(ngModel)]="to_date" readonly>
                    <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                    <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>
                <div class="form-group col-1.5">
                  <button type="button" style="margin-top: 30px;" class="btn btn-primary btn-fw" (click)="getList($event)">Load</button>
                </div>
                <div class="ml-auto p-2 bd-highlight" *ngIf = "permissionsService.checkPermission('add_dharmshala_booking')">
                  <div class="form-group" style="text-align:right;align-items: right;">
                    <a title="Add Dharmshala Booking"  (click) = "navigateTo('add-dharmshala-booking')"> <i class="fa fa-plus-circle" style="font-size: 35px;cursor: pointer;margin-top: 30px;" aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
          <h4 class="card-title">
            <div class="d-flex bd-highlight">
              <div class="p-2 flex-grow-1 bd-highlight">Dharmshala Booking List</div>
              <div class="p-2 bd-highlight">
                <button type="btn" class="btn btn-primary btn-fw" (click)="exportData()">Export</button>
              </div>
            </div>
          </h4>
          <div class="table-responsive" *ngIf="allDharmshalaBooking && allDharmshalaBooking.data && allDharmshalaBooking.data.length">
            <table class="table">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile No.</th>
                <th>Dharmshala Name</th>
                <th>Room Type</th>
                <!-- <th>Number of Room Booked</th> -->
                <th>Number of Days</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Payment Status</th>
                <!-- <th>City</th>
                <th>State</th> -->
                <th>Status</th>
                <th>Receipt</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let data of allDharmshalaBooking?.data; let i = index">
                <tr>
                  <td>
                    <span *ngIf = "page == 1">{{i+1}}</span>
                    <span *ngIf = "page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                  </td>
                  <td>{{data?.first_name}} {{data?.last_name}}</td>
                  <td>{{data?.mobile_no}}</td>
                  <td>{{data?.dharmshala_detail?.name}}</td>
                  <td>{{data?.booking_rooms.length && data?.booking_rooms[0].dharmshala_room?.room_type?.title}}</td>
                  <!-- <td>{{data?.no_of_rooms_booked}}</td> -->
                  <td>{{data?.no_of_days}}</td>
                  <td>{{data?.from_date}}</td>
                  <td>{{data?.to_date}}</td>
                  <td>{{data?.payment_status}}</td>
                  <!-- <td>{{data?.city?.name}}</td>
                  <td>{{data?.state?.name}}</td> -->
                  <td>{{data?.status}}</td>
                <td>
                  <a *ngIf="data.e_receipt_url" title="Receipt" [href]="data.e_receipt_url" target="_blank">
                    <i class="fa fa-download" style="font-size: 24px !important;" aria-hidden="true"></i>
                  </a>
                </td>
                
                  <td>
                    <a 
                      *ngIf="data?.booking_rooms && data?.booking_rooms.length > 0"
                      (click)="toggleBookingRooms(data.id)"
                      title="View Rooms"
                      style="cursor: pointer;">
                      <i class="fa" [ngClass]="expandedBookingId === data.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                    <a title="Dharmshala Detail" class="ml-4" routerLink = "/dharmshala-booking-detail/{{data.id}}">
                      <i class="fa fa-info-circle" style="font-size: 24px !important;" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="expandedBookingId === data.id && data?.booking_rooms && data?.booking_rooms.length > 0">
                  <td colspan="9" class="p-0">
                    <div class="bg-light p-3">
                      <h6 class="mb-3"><strong>Booked Rooms:</strong></h6>
                      <table class="table table-sm table-bordered mb-0">
                        <thead class="thead-light">
                          <tr>
                            <th>Room Type</th>
                            <th>No. of Rooms</th>
                            <th>No. of Extra Bed</th>
                            <th>Charges</th>
                            <th>Extra Bed Charges</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let room of data.booking_rooms">
                            <td>{{room?.dharmshala_room?.room_type?.title || 'N/A'}}</td>
                            <td>{{room?.no_of_rooms || 0}}</td>
                            <td>{{room?.no_of_extra_bed || 0}}</td>
                            <td>₹{{room?.dharmshala_room?.charges || 0}}</td>
                            <td>₹{{room?.dharmshala_room?.extra_bed_charges || 0}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
          <div class="p-12" *ngIf="allDharmshalaBooking && allDharmshalaBooking.data && !allDharmshalaBooking.data.length">
            <span class="ng-star-inserted no_data" >No Data found.</span>
          </div>
          <ngb-pagination  *ngIf="allDharmshalaBooking && allDharmshalaBooking.data && allDharmshalaBooking.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
          [(page)]="page" [maxSize]="3" (pageChange)="getList('pagination')"
          class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>

